// client/src/components/dashboard/SubjectSelection.tsx
import React, { useState } from "react";
import "../../assets/styles/dashboard.css";
import { useSubjects } from "../../hooks/useSubjects";

interface SubjectSelectionProps {
  grade?: string;
  term?: string;
  onSubjectsSelected?: (subjects: string[]) => void;
}

const SubjectSelectionComponent: React.FC<SubjectSelectionProps> = ({ 
  grade = "4", 
  term = "1", 
  onSubjectsSelected = () => {} 
}) => {
  const [selectedSubjects, setSelectedSubjects] = useState<string[]>([]);
  const { subjects, loading, error } = useSubjects(grade, term);

  const handleSubjectClick = (subjectId: string) => {
    const newSelectedSubjects = selectedSubjects.includes(subjectId)
      ? selectedSubjects.filter((s) => s !== subjectId)
      : [...selectedSubjects, subjectId];
    
    setSelectedSubjects(newSelectedSubjects);
    onSubjectsSelected(newSelectedSubjects);
  };

  if (loading) {
    return <div className="subject-selection">Loading subjects...</div>;
  }

  if (error) {
    return <div className="subject-selection error">{error}</div>;
  }

  return (
    <div className="subject-selection">
      <h2>Subject Selection</h2>
      <p>Select the subjects you would like to focus on:</p>
      <div className="subjects-list">
        {subjects.map((subject) => (
          <div
            key={subject.id}
            className={`subject-item ${selectedSubjects.includes(subject.id) ? "selected" : ""}`}
            onClick={() => handleSubjectClick(subject.id)}
          >
            {subject.name}
          </div>
        ))}
      </div>
      {selectedSubjects.length > 0 && (
        <div className="selected-subjects">
          <h3>Your Selected Subjects:</h3>
          <ul>
            {selectedSubjects.map((subjectId) => {
              const subject = subjects.find(s => s.id === subjectId);
              return <li key={subjectId}>{subject?.name}</li>;
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SubjectSelectionComponent;

export {};